<template>
  <div>
    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form
        :autocomplete="config.autocomplete === false ? 'off' : ''"
        @submit.stop.prevent="passes(onSubmit)"
      >
        <b-form-row>
          <b-col
            v-for="(field, indx) of config.fields"
            :key="indx"
            :cols="field.cols || 12"
            :sm="field.sm"
            :md="field.md"
            :lg="field.lg"
            :xl="field.xl"
          >
            <slot :fieldTitleText="field.titleText" name="titleText"></slot>
            <validation-provider
              v-if="!field.titleText"
              v-slot="validationContext"
              :vid="field.name"
              :name="field.text"
              :rules="field.rules"
            >
              <b-form-group
                class="form__group field"
                :class="{ 'mt-4': config.floatingLabels }"
                :label="!config.floatingLabels ? field.label : ''"
              >
                <b-form-input
                  v-if="
                      field.type !== 'select'
                      && field.type !== 'file'
                  "
                  :id="field.name"
                  class="form__field"
                  :type="field.type"
                  :placeholder="field.text"
                  :name="field.text"
                  :disabled="disabled || field.disabled"
                  :value="value && value[field.name] ? value[field.name] : ''"
                  :state="
                    field.rules ? getValidationState(validationContext) : null
                  "
                  :aria-describedby="`${field.name}-feedback`"
                  @input="handleChange($event, field.name)"
                ></b-form-input>
                <label
                  v-if="config.floatingLabels && field.type !== 'select'"
                  :for="field.name"
                  class="form__label"
                >{{ field.label }}</label>
                <b-form-select
                  v-if="field.type === 'select'"
                  :id="field.name"
                  v-model="value[field.name]"
                  :options="field.options"
                  :state=" field.rules ?getValidationState(validationContext) : null"
                  :value=" value && value[field.name] ? value[field.name] : null"
                  :name="field.text"
                  :disabled="disabled"
                  @change="handleChange($event, field.name)"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="undefined" disabled>-- {{ field.text }} --</b-form-select-option>
                  </template>
                </b-form-select>
                <b v-if="field.type === 'select' && field.name==='nomDis'" style="font-size:12px;">
                  En caso de no encontrar el nombre del Distribuidor, selecciona OTRO, al final de la lista.
                </b>
                <b-form-file
                  v-if="field.type === 'file'"
                  :id="field.name"
                  type="file"
                  :placeholder="field.text"
                  :name="field.text"
                  rsequired
                  :state="null"
                  browse-text="Seleccionar archivo"
                  :disabled="disabled || field.disabled"
                  @change="onFileChange($event)"
                ></b-form-file>
                <b-form-invalid-feedback :id="`${field.name}-feedback`">
                  {{
                  validationContext.errors[0]
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <VueRecaptcha
            class="m-4"
            v-if="config.recaptcha"
            :loadRecaptchaScript="true"
            sitekey="6LdS9L4ZAAAAAJG2wT5UgLWqMQL898kpfAkkekIN"
            @verify="verifyRecaptcha"
          ></VueRecaptcha>
          <div class="text-center w-100">
            <b-button
              type="submit"
              :class="config.submitClasses ? config.submitClasses : ''"
              :disabled="disabled || config.disabledButton"
            >
              <slot name="button-text">{{ config.submitText }}</slot>
            </b-button>
          </div>
        </b-form-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

// Rules documentation: https://logaretm.github.io/vee-validate/advanced/rules-object-expression.html#defining-rules
export default {
  name: "Form",
  components: {
    VueRecaptcha
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      select: null
    };
  },
  methods: {
    onFileChange(ev) {
      this.$emit("onFileChange", ev);
    },
    verifyRecaptcha() {
      this.$emit("validRecaptcha");
    },
    handleChange(val, field) {
      this.$emit("input", {
        ...(this.value ? this.value : {}),
        ...{ [field]: val }
      });
    },
    getValidationState({ touched, dirty, validated, valid = null }) {
      return (touched && dirty) || validated ? valid : null;
    },
    imageValidator(e) {
      console.log(e);
    },
    resetForm() {
      this.$emit("input", {});
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
    async onSubmit() {
      await this.$emit("submit");
      this.$nextTick(() => {
        //this.resetForm();
        this.$refs.observer.reset();
      });
    }
  }
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
